import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthModule } from '@carm/_auth/spartacus/core/auth';
import { ConfigModule } from '@carm/_auth/spartacus/core/config';
import { GlobalMessageModule } from '@carm/_auth/spartacus/core/global-message';
import { I18nModule } from '@carm/_auth/spartacus/core/i18n';
import { OccModule } from '@carm/_auth/spartacus/core/occ';
import { RoutingModule } from '@carm/_auth/spartacus/core/routing';
import { SiteContextModule } from '@carm/_auth/spartacus/core/site-context';
import { StateModule } from '@carm/_auth/spartacus/core/state';
import { EffectsModule } from '@ngrx/effects';
import { FullRouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { AppEffects } from './store/effects/app.effects';
import { metaReducers, reducers } from './store/reducers';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production , connectInZone: true}),
    EffectsModule.forRoot([AppEffects]),
    StoreRouterConnectingModule.forRoot({ serializer: FullRouterStateSerializer }),
    StateModule.forRoot(),
    SiteContextModule.forRoot(),
    AuthModule.forRoot(),
    I18nModule.forRoot(),
    GlobalMessageModule.forRoot(),
    OccModule.forRoot(),
    RoutingModule.forRoot(),
    ConfigModule.forRoot(),
    ConfigModule.withConfig(environment.storeConfig),
  ],
})
export class SiteConfigModule {}
